import axios from "axios";
import {
  ENVIROMENT,
  DEV_RECLASIFICACION_AUTH_CONSOLE,
  DEV_URL_DOMAIN_AUTH_FRECUENCIAS,
  DEV_CLIENT_ID_AUTH_FRECUENCIAS,
  PROD_NEW_AUTH_CONSOLE_FULL,
  PROD_URL_DOMAIN_AUTH_FRECUENCIAS,
  PROD_CLIENT_ID_AUTH_FRECUENCIAS,
} from "../../utilities";
import attachInterceptor from "../authInterceptor";
import { TokenCentralizado } from "../tokenCentralizado";
import { SelectToken } from "../SelectToken";

let tokenPromise = null;

let baseUrl;
let authUrl;
let clientId;
if (ENVIROMENT === "dev") {
  baseUrl = DEV_RECLASIFICACION_AUTH_CONSOLE;
  authUrl = DEV_URL_DOMAIN_AUTH_FRECUENCIAS;
  clientId = DEV_CLIENT_ID_AUTH_FRECUENCIAS;
} else {
  baseUrl = PROD_NEW_AUTH_CONSOLE_FULL;
  authUrl = PROD_URL_DOMAIN_AUTH_FRECUENCIAS;
  clientId = PROD_CLIENT_ID_AUTH_FRECUENCIAS;
}

const getToken = async (baseUrl) => {
  const identificador = await SelectToken(baseUrl);
  return localStorage.getItem(identificador);
};

const refreshToken = async () => {
  if (!tokenPromise) {
    tokenPromise = (async () => {
      try {
        const nuevoToken = await TokenCentralizado(authUrl, clientId, baseUrl);
        return nuevoToken;
      } catch (error) {
        console.error("Error al renovar el token:", error);
        throw error;
      } finally {
        tokenPromise = null;
      }
    })();
  }
  return tokenPromise;
};

const createAxiosInstanceNew = async () => {
  const token = await getToken(baseUrl);
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    // timeout: 10000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
      } else {
        config.headers["Content-Type"] = "application/json";
      }
      // Do something before sending the request
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      // Handle request errors
      return Promise.reject(error);
    }
  );

  attachInterceptor(axiosInstance, refreshToken, "isRefreshingFrecuencias");

  return axiosInstance;
};

// const axiosInstance = axios.create({
//   baseURL: baseUrl,
//   // timeout: 10000,
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     if (config.data instanceof FormData) {
//       config.headers["Content-Type"] = "multipart/form-data";
//     } else {
//       config.headers["Content-Type"] = "application/json";
//     }
//     // Do something before sending the request
//     config.headers.Authorization = `Bearer ${token}`;
//     return config;
//   },
//   (error) => {
//     // Handle request errors
//     return Promise.reject(error);
//   }
// );

// attachInterceptor(axiosInstance, refreshToken, "nuevooo");

export default createAxiosInstanceNew;
